import React, { useEffect, useState } from "react";
import { TabPanel, useTabs } from "react-headless-tabs";
import { useSelector } from "react-redux";
import logo from "./assets/logo.png";
import { syncUserProfileFromDB } from "./components/db";
import { Footer } from "./components/Footer";
import { Header } from "./components/Header";
import { MainContent } from "./components/MainContent";
import { BatTuNew } from "./page/BatTuNguoiNoiTieng";
import PageHoaGiap from "./page/Page60hoagiap";
import PageDungThanDieuHau from "./page/PageDungThanDieuHau";
import PageNguHanh from "./page/PageNguHanh";
import PageThanSat from "./page/pageThanSat";
import PageTieuNhiQuanSat from "./page/pageTieuNhiQuanSat";
import PageTinhCach from "./page/PageTinhCach";
import "./scss/style.scss";

function App() {
  const checkLogin = useSelector((state) => state.user);
  const [isProfileReady, setIsProfileReady] = useState(false);
  const [selectedTab, setSelectedTab] = useTabs([
    "/",
    "hoagiap",
    "thansat",
    "celebrity",
    "tieunhi",
    "tinhcach",
    "dungthandieuhau",
    "nguhanh",
  ]);
  const [isHistory, setIsHistory] = useState(0);
  const [dataNote, setDataNote] = useState("");

  useEffect(() => {
    let cancelled = false;

    const hydrateProfile = async () => {
      const storedProfile = localStorage.getItem("profile");

      if (!storedProfile) {
        if (!cancelled) {
          setIsProfileReady(true);
        }
        return;
      }

      if (!cancelled) {
        setIsProfileReady(false);
      }

      try {
        await syncUserProfileFromDB();
      } catch (error) {
        console.error("Unable to sync profile from Firestore:", error);
      } finally {
        if (!cancelled) {
          setIsProfileReady(true);
        }
      }
    };

    hydrateProfile();

    return () => {
      cancelled = true;
    };
  }, [checkLogin]);

  if (!isProfileReady) {
    return (
      <>
        <div className="loading show"></div>
        <img className="imagee show" src={logo} alt="loading indicator" />
      </>
    );
  }

  return (
    <>
      <div id="app__" style={{ width: "100%", margin: "0 auto" }}>
        <div id="container">
          <Header
            activeTab={(value) => setSelectedTab(value)}
            isHistory={(value) => setIsHistory(isHistory + value)}
            data_={(value) => setDataNote(value)}
          />
          <TabPanel hidden={selectedTab !== "/"}>
            <MainContent
              isHistory={isHistory}
              activeTab={(value) => setSelectedTab(value)}
              dataNote={dataNote}
            />
          </TabPanel>
          <TabPanel hidden={selectedTab !== "hoagiap"}>
            <PageHoaGiap />
          </TabPanel>
          <TabPanel hidden={selectedTab !== "thansat"}>
            <PageThanSat />
          </TabPanel>
          <TabPanel hidden={selectedTab !== "celebrity"}>
            <BatTuNew />
          </TabPanel>
          <TabPanel hidden={selectedTab !== "tieunhi"}>
            <PageTieuNhiQuanSat />
          </TabPanel>
          <TabPanel hidden={selectedTab !== "tinhcach"}>
            <PageTinhCach />
          </TabPanel>
          <TabPanel hidden={selectedTab !== "dungthandieuhau"}>
            <PageDungThanDieuHau />
          </TabPanel>
          <TabPanel hidden={selectedTab !== "nguhanh"}>
            <PageNguHanh />
          </TabPanel>
          <Footer />
        </div>
      </div>

      <div className={checkLogin ? "loading show" : "loading"}></div>
      <img
        className={checkLogin ? "imagee show" : "imagee"}
        src={logo}
        alt="background"
      />
    </>
  );
}

export default App;
